<script lang="ts" setup>
import type {
  Area,
  FocalPointAsset,
  FromResolver,
} from "#magnolia-layer/types/magnolia-types";
import type {PageLink} from "~/types/mgnl";
import type {AspectRatio} from "#base-layer/utils/parseAspectRatio";

const props = defineProps<{
  metadata: Area;
  title: string;
  abstract: string;
  category?: string;
  pageLink: PageLink;
  image: FromResolver<FocalPointAsset>;
  aspectRatio: "original" | AspectRatio;
}>();

// TODO: get it from the actual interview!?
const aspectRatioFallback = props.aspectRatio ?? "original";
const parsedRatio =
  aspectRatioFallback === "original"
    ? undefined
    : parseAspectRatio(aspectRatioFallback);
const extract =
  parsedRatio === undefined
    ? undefined
    : imageToExtractionArea(props.image, parsedRatio);

const pageLink = computed(() => {
  if (props.pageLink && props.pageLink["@path"]) {
    return {link: stripPrefix(props.pageLink["@path"])};
  }
  return undefined;
});
</script>

<template>
  <TextMediaLayout
    :compact="false"
    :link="pageLink"
    :category="category"
    :title="title">
    <template #media>
      <MagnoliaPicture
        :asset="image"
        :modifiers="{extract}"
        loading="lazy"
        sizes="400 md:600 lg:520 xl:640">
      </MagnoliaPicture>
    </template>
    {{ abstract }}
  </TextMediaLayout>
</template>

<style lang="scss" scoped></style>
